import { render, staticRenderFns } from "./TableAndChartCBC.vue?vue&type=template&id=02c8d9d9"
import script from "./TableAndChartCBC.vue?vue&type=script&lang=js"
export * from "./TableAndChartCBC.vue?vue&type=script&lang=js"
import style0 from "./TableAndChartCBC.vue?vue&type=style&index=0&id=02c8d9d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports